// Inviso RAM Tracking Pixel Configuration
// Each publication has unique tracking parameters that cannot be changed

export interface InvisoTrackingPixelConfig {
  i: string; // ID parameter
  c: string; // C parameter
  c1: string; // C1 parameter (publication name formatted)
}

export const invisoTrackingPixelConfig: {
  [domain: string]: InvisoTrackingPixelConfig;
} = {
  "abergavennychronicle.com": {
    i: "40066",
    c: "62784",
    c1: "Abergavenny_Chronicle_Online",
  },
  "altonherald.com": {
    i: "40069",
    c: "62788",
    c1: "Alton_Herald_Online",
  },
  "bordonherald.com": {
    i: "40073",
    c: "62791",
    c1: "Bordon_Herald_Online",
  },
  "brecon-radnor.co.uk": {
    i: "40074",
    c: "62793",
    c1: "Brecon_&_Radnor_Express_Online",
  },
  "bude-today.co.uk": {
    i: "40076",
    c: "62795",
    c1: "Bude_&_Stratton_Post_Online",
  },
  "cambrian-news.co.uk": {
    i: "40080",
    c: "62798",
    c1: "Cambrian_News_Online",
  },
  "chepstowbeacon.co.uk": {
    i: "40083",
    c: "62802",
    c1: "Chepstow_Beacon_Online",
  },
  "thepost.uk.com": {
    i: "40086",
    c: "62804",
    c1: "Cornish_&_Devon_Post_Online",
  },
  "cornish-times.co.uk": {
    i: "40089",
    c: "62807",
    c1: "Cornish_Times_Online",
  },
  "creditoncourier.co.uk": {
    i: "40091",
    c: "62809",
    c1: "Crediton_Courier_Online",
  },
  "dartmouth-today.co.uk": {
    i: "40092",
    c: "62810",
    c1: "Dartmouth_Chronicle_Online",
  },
  "dawlish-today.co.uk": {
    i: "40093",
    c: "62811",
    c1: "Dawlish_Gazette_Online",
  },
  "farnhamherald.com": {
    i: "40094",
    c: "62812",
    c1: "Farnham_Herald_Online",
  },
  "theforestreview.co.uk": {
    i: "40095",
    c: "62813",
    c1: "Forest_of_Dean_&_Wye_Valley_Review_Online",
  },
  "haslemereherald.com": {
    i: "40097",
    c: "62815",
    c1: "Haslemere_Herald_Online",
  },
  "holsworthy-today.co.uk": {
    i: "40098",
    c: "62816",
    c1: "Holsworthy_Post_Online",
  },
  "ivybridge-today.co.uk": {
    i: "40099",
    c: "62817",
    c1: "Ivybridge_&_South_Brent_Gazette_Online",
  },
  "kingsbridge-today.co.uk": {
    i: "40100",
    c: "62818",
    c1: "Kingsbridge_&_Salcombe_Gazette_Online",
  },
  "liphookherald.com": {
    i: "40101",
    c: "62819",
    c1: "Liphook_Herald_Online",
  },
  "middevonadvertiser.co.uk": {
    i: "40102",
    c: "62820",
    c1: "Mid_Devon_Advertiser_Online",
  },
  "mnrjournal.co.uk": {
    i: "40103",
    c: "62821",
    c1: "Midsomer_Norton_&_Radstock_Journal_Online",
  },
  "monmouthshirebeacon.co.uk": {
    i: "40104",
    c: "62822",
    c1: "Monmouthshire_Beacon_Online",
  },
  "narberth-and-whitland-today.co.uk": {
    i: "40105",
    c: "62823",
    c1: "Narbeth_&_Whitland_Observer_Online",
  },
  "okehampton-today.co.uk": {
    i: "40107",
    c: "62824",
    c1: "Okehampton_Times_Online",
  },
  "pembroke-today.co.uk": {
    i: "40108",
    c: "62825",
    c1: "Pembroke_&_Pembroke_Dock_Observer_Online",
  },
  "petersfieldpost.co.uk": {
    i: "40111",
    c: "62828",
    c1: "Petersfield_post_Online",
  },
  "southhams-today.co.uk": {
    i: "40114",
    c: "62830",
    c1: "South_Hams_Gazette_Online",
  },
  "tamarvalleytimes.co.uk": {
    i: "40131",
    c: "62866",
    c1: "Tamar_Valley_Times_Online",
  },
  "tavistock-today.co.uk": {
    i: "40116",
    c: "62833",
    c1: "Tavistock_Times_Gazette_Online",
  },
  "teignmouth-today.co.uk": {
    i: "40118",
    c: "62835",
    c1: "Teignmouth_Post_Online",
  },
  "tenby-today.co.uk": {
    i: "40120",
    c: "62837",
    c1: "Tenby_Observer_Online",
  },
  "theforester.co.uk": {
    i: "40121",
    c: "62838",
    c1: "The_Forester_Online",
  },
  "rossgazette.com": {
    i: "40122",
    c: "62839",
    c1: "The_Ross_Gazette_Online",
  },
  "totnes-today.co.uk": {
    i: "40123",
    c: "62840",
    c1: "Totnes_Times_Online",
  },
  "voicenewspapers.co.uk": {
    i: "40124",
    c: "62841",
    c1: "Voice_Online",
  },
  "wellington-today.co.uk": {
    i: "40125",
    c: "62842",
    c1: "Wellington_Weekly_News_Online",
  },
  "wsfp.co.uk": {
    i: "40126",
    c: "62843",
    c1: "West_Somerset_Free_Press_Online",
  },
  "wokingnewsandmail.co.uk": {
    i: "40127",
    c: "62844",
    c1: "Woking_News_&_Mail_Online",
  },
  // Template for new publications:
  // "domain.com": {
  //   i: "XXXXX",
  //   c: "XXXXX",
  //   c1: "Publication_Name_Online"
  // },
};

// Base URL for all Inviso RAM tracking pixels
export const INVISO_TRACKING_PIXEL_BASE_URL =
  "https://inviso.rampanel.com/ram/Inviso";

// Fixed parameters that are the same for all Inviso tracking pixels
export const INVISO_FIXED_TRACKING_PARAMS = {
  t: "6",
  cg: "0",
  r: "1",
  rdir: "1",
  c0: "Tindle_Newspapers_Ltd",
};

/**
 * Generates a cachebuster parameter to ensure tracking pixels bypass CloudFlare cache
 * Uses timestamp + random number for uniqueness
 */
export const generateCachebuster = (): string => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 10000);
  return `${timestamp}_${random}`;
};
